import React, { useEffect, useState } from 'react';
import { Provider, useDispatch, useSelector } from 'react-redux';
import ReportFile from './ReportFile';
import { store } from '../..';
import { pdf } from '@react-pdf/renderer';
import { getReport } from '../../slices/thunks';
import { saveAs } from 'file-saver';

const PDFReport = ({ id, name }) => {
    const dispatch = useDispatch();
    const [isDownloading, setIsDownloading] = useState(false);
    const { report, isLoadingList } = useSelector(state => ({
        report: state.Report.itemReportDetail,
        isLoadingList: state.Report.isLoadingList
    }));

    useEffect(() => {
        dispatch(getReport(id));
    }, [dispatch, id]);

    const downloadPdf = async () => {
        if (isDownloading) return; // Evita múltiples descargas simultáneas

        setIsDownloading(true); // Inicia el proceso de descarga

        try {
            // Crear una copia profunda del reporte para modificarla sin afectar Redux
            const reportCopy = JSON.parse(JSON.stringify(report));

            if (reportCopy) {
                reportCopy.pages.forEach(page => {
                    page.elements = page.elements.map(element => ({
                        ...element,
                        imageDetails: { // Agregar atributo imageDetails a la copia
                            url: "https://eussped201.blob.core.windows.net/static/report-title_aae6d0b079c9f9051a8c51dd6.jpg",
                            hash: "report-title_aae6d0b079c9f9051a8c51dd6",
                        }
                    }));
                });
            }

            const blob = await pdf(
                <Provider store={store}>
                    <ReportFile report={reportCopy} />
                </Provider>
            ).toBlob();
            saveAs(blob, `${name}.pdf`.toUpperCase());
        } catch (error) {
            console.error("Failed to generate PDF:", error);
        } finally {
            setIsDownloading(false); // Finaliza el proceso de descarga
        }
    };

    return (
        <button
            type="button"
            className="btn btn-primary w-100 mt-2"
            onClick={downloadPdf}
            disabled={isDownloading || !report} // Deshabilita si está descargando o si no hay reporte
        >
            {isDownloading ? (
                <span>Cargando PDF...</span>
            ) : (
                <>
                    <i className="ri-download-line"></i> Descargar PDF
                </>
            )}
        </button>
    );
};

export default PDFReport;
